export enum RequestStatus {
  'Aprobado' = 'Aprobado',
  'CANCELADA' = 'CANCELADA',
  'INICIADO' = 'INICIADO'
}

export enum RequestCancelReason {
  SELLER_CANCELS = 'El vendedor cancela la solicitud',
  CUSTOMER_CANCELS = 'El cliente cancela la solicitud',
  NO_PRODUCTS_AVAILABLE = 'No hay productos disponibles para el cliente',
  REQUEST_NOT_APPROVED = 'Solicitud no aprobada',
  CUSTOMER_VERIFICATION_ISSUE = 'Problemas en la verificacion del cliente',
  FROM_POINT_OF_SALES = 'Cancelacion desde el paso Punto de Venta'

}

export enum AgreementStatus {
  'FIRMADO' = 'FIRMADO',
  'ANULADO' = 'ANULADO',
  'INICIADO' = 'INICIADO'
}